import { AuthGuardService } from '../services/auth-guard.service';
import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MemberProfileComponent} from './member.profile/member.profile.component'

const MembersAccountRouting: Routes = [
    // login view
    {

        path: 'member-profile', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: MemberProfileComponent },
            { path: ':id', component: MemberProfileComponent },

            // handle all other routes
            { path: '**', component: MemberProfileComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(MembersAccountRouting)],
    exports: [RouterModule]
})
export class MembersAccountRoutingModule { }
